//Reducer

const defaultState = {
  type: "",
  payload: {},
};
const userReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SET_USER":
      return {
        type: "SET_USER",
        payload: action.payload,
      };
    case "UN_SET_USER":
      return {
        type: "UN_SET_USER",
        payload: {},
      };
    default:
      return state;
  }
};

export default userReducer;
